/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { GridCellBase } from "./GridCellBase";
import { GridSortIndicator } from "./GridSortIndicator";
import { GridFilterDialog } from "./GridFilterDialog";
import { ColumnOptionsIconBehavior_$type } from "./ColumnOptionsIconBehavior";
import { ColumnOptionsIconAlignment_$type } from "./ColumnOptionsIconAlignment";
import { enumGetBox, runOn, delegateCombine, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var TextHeaderCell = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TextHeaderCell, _super);
    function TextHeaderCell(a) {
        var _this = _super.call(this, a) || this;
        _this.ce = null;
        _this.ca = null;
        _this.b8 = null;
        _this.b4 = 0;
        _this.b3 = 0;
        _this.b6 = 3;
        _this.cg = null;
        _this.cj = -1;
        _this.ci = -1;
        _this.cc = false;
        _this.cf = null;
        _this.cd = false;
        _this.ce = a.createElement("span");
        _this.z.setRawStyleProperty("text-align", "left");
        _this.z.setRawStyleProperty("vertical-align", "middle");
        _this.ce.setRawStyleProperty("display", "inline-block");
        _this.ce.setRawStyleProperty("line-height", "normal");
        _this.ce.setRawStyleProperty("vertical-align", "middle");
        _this.ce.setRawStyleProperty("overflow", "hidden");
        _this.ce.setRawStyleProperty("white-space", "nowrap");
        _this.ce.setRawStyleProperty("text-overflow", "ellipsis");
        _this.z.append(_this.ce);
        var b = 18;
        var c = 18;
        var d = a.createElement("div");
        d.setRawStyleProperty("display", "none");
        d.setRawStyleProperty("vertical-align", "middle");
        d.setRawStyleProperty("width", b + "px");
        d.setRawStyleProperty("height", c + "px");
        _this.cf = d;
        var e = a.getSubRenderer(d);
        _this.b8 = new GridFilterDialog();
        _this.b8.bf(e, _this.z, a);
        _this.z.append(d);
        _this.b8.a8(b, c);
        _this.b8.af = 24;
        var f = _this.b8.x;
        _this.b8.x = false;
        _this.b8.a5();
        _this.b8.x = f;
        var g = 18;
        var h = 18;
        d = a.createElement("div");
        d.setRawStyleProperty("display", "inline-block");
        d.setRawStyleProperty("vertical-align", "middle");
        d.setRawStyleProperty("width", "0px");
        d.setRawStyleProperty("height", h + "px");
        d.setRawStyleProperty("margin", "0 0 0 5px");
        _this.cg = d;
        e = a.getSubRenderer(d);
        _this.ca = new GridSortIndicator();
        _this.ca.l = false;
        _this.ca.ax(e);
        _this.z.append(d);
        _this.ca.ar(g, h);
        var i = _this.ca;
        i.propertyChanged = delegateCombine(i.propertyChanged, runOn(_this, _this.cm));
        var j = _this.b8;
        j.dialogOpening = delegateCombine(j.dialogOpening, runOn(_this, _this.cn));
        var k = _this.b8;
        k.filterChanging = delegateCombine(k.filterChanging, runOn(_this, _this.cp));
        var l = _this.b8;
        l.filterChanged = delegateCombine(l.filterChanged, runOn(_this, _this.co));
        _this.z.listen("mouseenter", runOn(_this, _this.ct));
        _this.z.listen("mouseleave", runOn(_this, _this.cs));
        return _this;
    }
    Object.defineProperty(TextHeaderCell.prototype, "ch", {
        get: function () {
            return this.ce;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextHeaderCell.prototype, "cb", {
        get: function () {
            return this.ca;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextHeaderCell.prototype, "b9", {
        get: function () {
            return this.b8;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextHeaderCell.prototype, "b7", {
        get: function () {
            return this.b6;
        },
        set: function (a) {
            var b = this.b6;
            this.b6 = a;
            this.bd("ColumnOptionsIconBehavior", enumGetBox(ColumnOptionsIconBehavior_$type, b), enumGetBox(ColumnOptionsIconBehavior_$type, this.b6));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextHeaderCell.prototype, "b5", {
        get: function () {
            return this.b4;
        },
        set: function (a) {
            var b = this.b4;
            this.b4 = a;
            this.bd("ColumnOptionsIconAlignment", enumGetBox(ColumnOptionsIconAlignment_$type, b), enumGetBox(ColumnOptionsIconAlignment_$type, this.b4));
        },
        enumerable: true,
        configurable: true
    });
    TextHeaderCell.prototype.s = function (a) {
        return true;
    };
    TextHeaderCell.prototype.bs = function (a, b) {
        _super.prototype.bs.call(this, a, b);
        a -= 21;
        if (this.cd) {
            a -= 15;
        }
        var c = Math.max(0, a - b);
        if (c != this.cj) {
            this.cj = c;
            this.ce.setRawStyleProperty("max-width", c.toString() + "px");
        }
    };
    TextHeaderCell.prototype.bm = function (a, b) {
        _super.prototype.bm.call(this, a, b);
        var c = Math.max(0, a - b);
        if (this.ci != c) {
            this.ci = c;
            this.ce.setRawStyleProperty("max-height", c.toString() + "px");
        }
    };
    TextHeaderCell.prototype.bt = function (a, b, c, d) {
        this.b8.a7();
    };
    TextHeaderCell.prototype.cm = function (a, b) {
        switch (b.propertyName) {
            case "CurrentOpacity":
                if (this.cb.r > 0) {
                    this.cg.setRawStyleProperty("width", "18px");
                    if (this.b3 == 2) {
                        this.cg.setRawStyleProperty("margin", "0 5px 0 0");
                    }
                    else {
                        this.cg.setRawStyleProperty("margin", "0 0 0 5px");
                    }
                }
                else {
                    this.cg.setRawStyleProperty("width", "0px");
                    this.cg.setRawStyleProperty("margin", "0");
                }
                break;
        }
    };
    TextHeaderCell.prototype.ct = function (a) {
        if (this.b.isGridDragging) {
            return;
        }
        switch (this.b7) {
            case 2:
            case 3:
                this.b8.bk();
                break;
        }
    };
    TextHeaderCell.prototype.cs = function (a) {
        switch (this.b7) {
            case 2:
            case 3:
                this.b8.a5();
                break;
        }
    };
    TextHeaderCell.prototype.co = function (a, b) {
        this.b.columnFilterChanged(b.a);
    };
    TextHeaderCell.prototype.cp = function (a, b) {
        this.b.columnFilterChanging(b.a);
    };
    TextHeaderCell.prototype.cn = function (a, b) {
        if (this.b != null) {
            b.a = this.d.getColumn();
            this.b.cancelEditMode(false);
        }
    };
    TextHeaderCell.prototype.bb = function (a, b, c) {
        _super.prototype.bb.call(this, a, b, c);
        this.b3 = c;
        this.b8.k = c;
        if (c == 2) {
            this.z.removeChild(this.cg);
            this.z.removeChild(this.cf);
            this.ce.before(this.cf);
            this.cf.before(this.cg);
            if (this.b5 == 1) {
                this.cf.setRawStyleProperty("margin", "0 5px 0 0");
                this.b8.l = this.b3;
            }
            else {
                this.cf.setRawStyleProperty("margin", "0");
                this.b8.l = 0;
            }
        }
        else {
            this.z.removeChild(this.cg);
            this.z.removeChild(this.ce);
            this.cf.before(this.ce);
            this.cf.before(this.cg);
            if (this.b5 == 1) {
                this.cf.setRawStyleProperty("margin", "0 0 0 5px");
                this.b8.l = this.b3;
            }
            else {
                this.cf.setRawStyleProperty("margin", "0");
                this.b8.l = 2;
            }
        }
    };
    TextHeaderCell.prototype.bq = function (a, b, c, d) {
        _super.prototype.bq.call(this, a, b, c, d);
        this.b8.ai = a;
        this.b8.aj = c;
    };
    TextHeaderCell.prototype.cr = function () {
        if (this.b5 == 2 || this.b5 == 0) {
            if (this.b3 == 2) {
                this.b8.l = 0;
            }
            else {
                this.b8.l = 2;
            }
        }
        else {
            this.b8.l = this.b3;
            if (this.b3 == 2) {
                this.cf.setRawStyleProperty("margin", "0 5px 0 0");
            }
            else {
                this.cf.setRawStyleProperty("margin", "0 0 0 5px");
            }
        }
    };
    TextHeaderCell.prototype.cq = function () {
        switch (this.b7) {
            case 1:
                this.b8.x = false;
                this.b8.bk();
                break;
            case 2:
                this.b8.x = false;
                break;
            case 3:
                this.b8.x = true;
                break;
        }
    };
    TextHeaderCell.prototype.bd = function (a, b, c) {
        _super.prototype.bd.call(this, a, b, c);
        switch (a) {
            case "ColumnOptionsIconAlignment":
                this.cr();
                break;
            case "ColumnOptionsIconBehavior":
                this.cq();
                break;
        }
    };
    TextHeaderCell.prototype.onContactStarted = function (e_, a) {
        if (e_.button == 2) {
            return;
        }
        var filterIconCanvas_ = this.b8.aq();
        var b = (e_.originalEvent.srcElement === filterIconCanvas_ || e_.originalEvent.target === filterIconCanvas_);
        if (b) {
            this.cc = true;
            return;
        }
        if (this.b8.y) {
            this.b8.a2();
        }
        _super.prototype.onContactStarted.call(this, e_, a);
    };
    TextHeaderCell.prototype.onContactCompleted = function (e_, a) {
        if (!this.cc) {
            _super.prototype.onContactCompleted.call(this, e_, a);
        }
        this.cc = false;
    };
    TextHeaderCell.prototype.get_q = function () {
        return true;
    };
    TextHeaderCell.$t = markType(TextHeaderCell, 'TextHeaderCell', GridCellBase.$);
    return TextHeaderCell;
}(GridCellBase));
export { TextHeaderCell };
//# sourceMappingURL=TextHeaderCell.js.map
